import ListHeader from '@/components/ListHeader'
import ListTable from '@/components/ListTable'
import { mapState } from 'vuex'

export default {
    components: {
        ListHeader,
        ListTable,
    },

    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: '姓名',
                },
                {
                    key: 'point',
                    label: '獲得積分',
                    formatter: value => {
                        return value + 'P'
                    }
                },
                {
                    key: 'actions',
                    label: '功能',
                    thStyle: { width: '25%' },
                }
            ]
        }
    },

    computed: {
        ...mapState({
            customers: state => state.users,
        })
    }
}